const MODULE = `SEARCH`

export const OPEN_SEARCH = `${MODULE}/OPEN_SEARCH`
export const CLOSE_SEARCH = `${MODULE}/CLOSE_SEARCH`

export const SEARCH_FOR_STORES = `${MODULE}/SEARCH_FOR_STORES`
export const SEARCH_FOR_STORES_LOGIC = `${SEARCH_FOR_STORES}_LOGIC`
export const SEARCH_FOR_STORES_SUCCESS = `${SEARCH_FOR_STORES}_SUCCESS`
export const SEARCH_FOR_STORES_ERROR = `${SEARCH_FOR_STORES}_ERROR`

export const SET_SEARCH_INPUT_VALUE = `${MODULE}/SET_SEARCH_INPUT_VALUE`

export const START_TYPING = `${MODULE}/START_TYPING`
export const STOP_TYPING = `${MODULE}/STOP_TYPING`

export const TOGGLE_ITEM = `${MODULE}/TOGGLE_ITEM`
export const CLEAR_ALL = `${MODULE}/CLEAR_ALL`
export const CLOSE_DETAILS = `${MODULE}/CLOSE_DETAILS`
export const TOGGLE_DETAILS = `${MODULE}/TOGGLE_DETAILS`
export const TOGGLE_SELECTED = `${MODULE}/TOGGLE_SELECTED`
